/* Copyright (c)2024 Sky Co., LTD. All rights reserved. */


import { defineStore } from 'pinia';
//import HttpRequestUtil from '@/util/HttpRequestUtil';
import { SelectedDivisionInfo } from '@/models/DivisionData'

export const useSelectedDivisionStore = defineStore('selectedDivision', {
    state: () => ({
        divisionId: 0,
        divisionName: '',
        enableChildDivision: false,
        defaultDivisionId: 0,
        defaultDivisionName: ''
    }),
    actions: {
        setDivisionInfo(id: number, name: string, enableChild: boolean) {
            this.divisionId = id;
            this.divisionName = name;
            if (undefined != enableChild) {
                this.enableChildDivision = enableChild;
            }

            // セッションマネージャの選択部署情報を更新
            //HttpRequestUtil.post("/Division/UpdateSelectedDivisionInfo",
            //    {
            //        "DivisionID": this.divisionId,
            //        "DivisionName": this.divisionName,
            //        "EnableChildDivision": this.enableChildDivision
            //
            //    });    // レスポンスは不問。awaitも行わない
        },
        setDivisionInfoWithoutEnableChildDivision(id: number, name: string) { // 配下全表示のみ更新しない
            this.divisionId = id;
            this.divisionName = name;

            // セッションマネージャの選択部署情報を更新
            //HttpRequestUtil.post("/Division/UpdateSelectedDivisionInfo",
            //    {
            //        "DivisionID": this.divisionId,
            //        "DivisionName": this.divisionName,
            //        "EnableChildDivision": this.enableChildDivision
            //
            //    });    // レスポンスは不問。awaitも行わない
        },
        async getDivisionInfo(): Promise<SelectedDivisionInfo> {

            // 初期値はネットワーク全体＆配下表示ON
            let divisionInfo = new SelectedDivisionInfo();
            divisionInfo.divisionId = this.defaultDivisionId;
            divisionInfo.divisionName = this.defaultDivisionName

            // すでに有効な部署情報がセットされている場合はそれを返す
            if (0 < this.divisionId) {
                divisionInfo.divisionId = this.divisionId;
                divisionInfo.divisionName = this.divisionName;
                divisionInfo.enableChildDivision = this.enableChildDivision;
            }
            // ストアの情報がない場合は、ログインセッションから取得
            else {
                // セッションマネージャから選択部署情報を取得
                //let res = await HttpRequestUtil.get("/Division/GetSelectedDivisionInfo");
                //if (res.status == 200) {
                //    // 成功
                //    if (undefined != res.data.selectedDivisionInfo) {
                //        if (0 < res.data.selectedDivisionInfo.divisionID) {
                //
                //            this.divisionId = res.data.selectedDivisionInfo.divisionID;
                //            this.divisionName = res.data.selectedDivisionInfo.divisionName;
                //            this.enableChildDivision = res.data.selectedDivisionInfo.enableChildDivision;
                //
                //            divisionInfo.divisionId = this.divisionId;
                //            divisionInfo.divisionName = this.divisionName;
                //            divisionInfo.enableChildDivision = this.enableChildDivision;
                //        }
                //    }
                //}

                // 失敗時や有効な部署情報でない場合は、初期値が返される
            }

            return divisionInfo;
        },
        setDefaultDivision(id: number, name: string) {
            this.defaultDivisionId = id;
            this.defaultDivisionName = name;
        }
    },
    getters: {
    },
});

/* Copyright (c)2024 Sky Co., LTD. All rights reserved. */
